import styled from 'styled-components';
import { CustomizedTypography, Stack, VStack } from '@components/Customized';
import { CapaQuotationUserRefundBankAccountModel } from '@generated/graphql';
import { CapaBankCodeToBankInfo } from '@routes/MyAccount/components/BankAccount/BankAccountInputGroup/BankAccountInputGroup';
import { bankMap } from '@utils/bankMap';
import { maskingBankAccount } from '@utils/maskingString';

interface RefundAccountProps {
  refundAccount: CapaQuotationUserRefundBankAccountModel;
}

const RefundAccount: React.FunctionComponent<RefundAccountProps> = ({
  refundAccount
}) => {
  const bankName = bankMap(refundAccount.bankCode);
  const bankLogo = CapaBankCodeToBankInfo[refundAccount?.bankCode]?.logo;
  const holderName = refundAccount?.holderName;
  const accountNumber = maskingBankAccount(refundAccount?.account);

  return (
    <Stack gap={8}>
      <BankLogo>
        <img src={bankLogo ?? ''} alt={bankMap(refundAccount.bankCode)} />
      </BankLogo>
      <VStack>
        <CustomizedTypography
          variant="body2"
          fontWeight="500"
          color="textPrimary"
        >
          {holderName}
        </CustomizedTypography>

        <Stack gap={4}>
          <CustomizedTypography variant="body2" color="textPrimary">
            {bankName}
          </CustomizedTypography>
          <CustomizedTypography variant="body2" color="textSecondary">
            {accountNumber}
          </CustomizedTypography>
        </Stack>
      </VStack>
    </Stack>
  );
};

export default RefundAccount;

const BankLogo = styled('div')`
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  overflow: 'hidden';
  & img {
    width: 100%;
    height: auto;
  }
`;
